import React from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import { find, maxBy, isEqual, cloneDeep } from 'lodash';

import config from '../../../config/config';
import Box from '../../common/Box';
import LineChart from '../../widgets/charts/types/LineChart';


class CatalogLineChart extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
		  mode: props.defaultMode || "tracks",
		};
	}

	setChartMode(mode){
		this.setState({mode}, ()=>{
		});

		const { modeChange } = this.props;
		if(typeof modeChange == 'function')
			modeChange(mode);
	}
	
	
	render (){
		const { stats } = this.props;
		
		return <div className="chart-block">
			<LineChart shadowChart={true} shadowChartWidth={800} shadowChartHeight={300} data={stats} id={'spotify_monetization_metrics'} />                          
		</div>
	}
}

export default CatalogLineChart;